import { iDateToIsoDateTime, jsDateToLocalIDate } from "./dates";
import h from "./html";

export default function DatePicker({
  dtStart,
  dtEnd,
}: {
  dtStart: h.State<string>;
  dtEnd: h.State<string>;
}) {
  const firstOfMonth = h.derive(() => {
    const firstOfMonth = new Date(iDateToIsoDateTime(dtStart.val));
    firstOfMonth.setDate(1);
    return firstOfMonth;
  });
  const firstWeekday = h.derive(() => firstOfMonth.val.getDay());

  return (
    <div className="mb-4 flex">
      <div>
        <h2 className="text-2xl text-gray-500 text-center">
          <a
            href="javascript:void(0)"
            className="text-blue-500"
            onclick={(ev: MouseEvent) => {
              ev.preventDefault();
              const first = new Date(firstOfMonth.val);
              first.setDate(0);

              dtStart.val = jsDateToLocalIDate(first);
              dtEnd.val = jsDateToLocalIDate(firstOfMonth.val);
            }}
          >
            ←
          </a>{" "}
          {() =>
            firstOfMonth.val.toLocaleDateString(undefined, {
              month: "long",
              year: "numeric",
            })
          }{" "}
          <a
            href="javascript:void(0)"
            className="text-blue-500"
            onclick={(ev: MouseEvent) => {
              ev.preventDefault();
              const first = new Date(firstOfMonth.val);
              first.setMonth(first.getMonth() + 1);

              const next = new Date(first);
              next.setDate(2);

              dtStart.val = jsDateToLocalIDate(first);
              dtEnd.val = jsDateToLocalIDate(next);
            }}
          >
            →
          </a>
        </h2>
        {() => (
          <div className="grid grid-cols-7 w-72 text-center">
            {new Array(7).fill(null).map((_, i) => {
              const day = new Date(firstOfMonth.val);
              day.setDate(i + 1 - firstWeekday.val);
              return (
                <div className="font-bold">
                  {day.toLocaleDateString(undefined, { weekday: "narrow" })}
                </div>
              );
            })}
            {new Array(firstWeekday.val >= 5 ? 42 : 35)
              .fill(null)
              .map((_, i) => {
                const day = new Date(firstOfMonth.val);
                day.setDate(i + 1 - firstWeekday.val);
                const iDate = jsDateToLocalIDate(day);
                const selected = iDate >= dtStart.val && iDate < dtEnd.val;
                return (
                  <a
                    href="javascript:void(0)"
                    className={`rounded-full ${day.getMonth() === firstOfMonth.val.getMonth() || selected ? "text-black" : "text-gray-300"} ${selected ? "bg-gray-300" : "underline"}`}
                    onclick={(ev) => {
                      ev.preventDefault();
                      dtStart.val = iDate;
                      const nextDay = new Date(day);
                      nextDay.setDate(nextDay.getDate() + 1);
                      dtEnd.val = jsDateToLocalIDate(nextDay);
                    }}
                  >
                    {day.getDate()}
                  </a>
                );
              })}
          </div>
        )}
      </div>
      <div className="grow" />
    </div>
  );
}
